export default __webpack_public_path__ + "static/image11-ce52d7cacaaf1eee363ab7b4cb611a3c.jpeg";